import React, { useState } from "react";
import { Container } from "../../styles/Styles";
import GuideNav from "./GuideNav";
import { useQuery } from "@apollo/client";
import { GET_MY_GUIDE_REVIEWS } from "../gql/guide-reviews-gql";
import ReviewMonthCalendar from "../common/ReviewMonthCalendar";
import GuideReviewImage from "../common/GuideReviewImage";
import { GuideReview } from "../common/interfaces";
import Loader from "../common/Loader";
import { useAuth } from "../../context/AuthContext";
import { Roles } from "../common/roles";
import { Navigate } from "react-router-dom";
import styled from "styled-components";
import moment from "moment/moment";

const Section = styled.div`
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;
`;

const MonthLabel = styled.h3`
    margin: 0 0 1rem 0;
    color: #333;
`;

const ReviewGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1rem;
`;

const ReviewItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

const ReviewMeta = styled.span`
    font-size: 0.85rem;
    color: #666;
`;

const GuideReviews = () => {
    const { user, isAuthenticated } = useAuth();
    const [currentMonth, setCurrentMonth] = useState(() => new Date());

    const queryVars = {
        month: currentMonth.getMonth() + 1,
        year: currentMonth.getFullYear(),
    };

    const { data, loading } = useQuery(GET_MY_GUIDE_REVIEWS, {
        variables: queryVars,
        skip: !isAuthenticated,
    });

    const reviews: GuideReview[] = data?.getMyGuideReviews || [];

    if (!isAuthenticated || user?.role[0] !== Roles.GUIDE) {
        return <Navigate to="/" />;
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <Container>
            <GuideNav />
            <h2>Reviews</h2>

            <ReviewMonthCalendar
                currentDate={currentMonth}
                onMonthChange={setCurrentMonth}
            />

            <Section>
                <MonthLabel>Reviews for {moment(currentMonth).format("MMMM YYYY")}</MonthLabel>
                {reviews.length === 0 ? (
                    <p>No reviews for this month.</p>
                ) : (
                    <ReviewGrid>
                        {reviews.map((review) => (
                            <ReviewItem key={review._id}>
                                <GuideReviewImage reviewId={review._id} alt="My review" />
                                <ReviewMeta>
                                    Added {moment(review.createdAt).format("D MMM YYYY h:mm a")}
                                </ReviewMeta>
                            </ReviewItem>
                        ))}
                    </ReviewGrid>
                )}
            </Section>
        </Container>
    );
};

export default GuideReviews;
